import { mergeClasses } from "@fluentui/react-components";

export const LabelValue = ({
    label,
    value,
    labelClassName = null,
    valueClassName = null,
    wrapper = null,
    wrapperProps = null,
}) => {
    let labelEle = (
        <div className={mergeClasses("whitespace-nowrap", labelClassName)}>
            {label}
        </div>
    );
    let valueEle = (
        <div className={mergeClasses("whitespace-nowrap", valueClassName)}>
            {value}
        </div>
    );
    if (wrapper) {
        let Wrapper = wrapper;
        return (
            <Wrapper {...wrapperProps}>
                {labelEle}
                {valueEle}
            </Wrapper>
        );
    }
    return (
        <>
            {labelEle}
            {valueEle}
        </>
    );
};
